import { StoreWorkingHours } from "../../../../../types";
import axios from "../../axios";
import * as Requests from "../../requests";

// get store working hours
export const getStoreWorkingHours = (token: string, scheduleId: string) => {
  return axios.get(Requests.WORKING_HOURS_INTERVALS_API(scheduleId), {
    headers: {
      token,
    },
    baseURL: process.env.PICKUP_ENDPOINTS,
  });
};

// update store working hours
export const updateStoreWorkingHours = (
  token: string,
  payload: {
    data: StoreWorkingHours;
    schedule_id: string;
  }
) => {
  return axios.put(
    Requests.WORKING_HOURS_INTERVALS_API(payload.schedule_id),
    payload.data,
    {
      headers: {
        token,
      },
      baseURL: process.env.PICKUP_ENDPOINTS,
    }
  );
};
